// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-img img {
  height: auto;
  width: 100%;
}

.pc-title h2 {
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
  margin-top: 0px;
  padding-bottom: 0px;
}

.comp-percent-rating {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.course-rating .star {
  color: #cfccc2;
}

.product-card {
  border-radius: 30px;
  background: #fff;
  box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
  border: medium none currentColor !important;
  border: initial !important;
  height: 430px;
}

.product-desc {
  height: 50px;
  margin-bottom: 5px;
}

.course-progress-pc .progress {
  height: 5px !important;
  border-radius: 40px;
  border: 2px solid var(--dPink);
  background: #fff;
}

.course-progress-pc .progress .progress-bar {
  background-color: var(--dPink) !important;
}

.vertical-ellipsis {
  position: absolute;
  top: 2%;
  right: 0;
}

.vertical-ellipsis svg {
  color: var(--white);
  font-size: 30px;
  font-weight: 900;
}

.card-play-btn-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ff5685;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-play-button {
  font-size: 30px;
  color: #fff;
}

.product-card-content{
  justify-content: space-between;
  height: 100%;
}

.product-card-top{
  height: 65%;
}

.product-card-bottom{
  height: 35%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.course-rating{
  text-align: right;
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/component/common/cards/ProductCard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,2CAAwB;EAAxB,0BAAwB;EACxB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".product-img img {\r\n  height: auto;\r\n  width: 100%;\r\n}\r\n\r\n.pc-title h2 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n  margin-top: 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.comp-percent-rating {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.course-rating .star {\r\n  color: #cfccc2;\r\n}\r\n\r\n.product-card {\r\n  border-radius: 30px;\r\n  background: #fff;\r\n  box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);\r\n  border: unset !important;\r\n  height: 430px;\r\n}\r\n\r\n.product-desc {\r\n  height: 50px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.course-progress-pc .progress {\r\n  height: 5px !important;\r\n  border-radius: 40px;\r\n  border: 2px solid var(--dPink);\r\n  background: #fff;\r\n}\r\n\r\n.course-progress-pc .progress .progress-bar {\r\n  background-color: var(--dPink) !important;\r\n}\r\n\r\n.vertical-ellipsis {\r\n  position: absolute;\r\n  top: 2%;\r\n  right: 0;\r\n}\r\n\r\n.vertical-ellipsis svg {\r\n  color: var(--white);\r\n  font-size: 30px;\r\n  font-weight: 900;\r\n}\r\n\r\n.card-play-btn-wrapper {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: #ff5685;\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.card-play-button {\r\n  font-size: 30px;\r\n  color: #fff;\r\n}\r\n\r\n.product-card-content{\r\n  justify-content: space-between;\r\n  height: 100%;\r\n}\r\n\r\n.product-card-top{\r\n  height: 65%;\r\n}\r\n\r\n.product-card-bottom{\r\n  height: 35%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.course-rating{\r\n  text-align: right;\r\n  padding-top: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
